import axios from 'axios';
import router from '@/router/router';
import Loading from 'quasar/src/plugins/Loading.js';;

export default {
  namespaced: true,
  state: {
    userInfo: {},
    uploadFiles: [],
    VisiblePermission: 'ALL',
    Content: '',
    TagFriend: [],
    urlData: {
      image: require('@/assets/img/default_link.jpg'),
      title: '',
      description: ''
    },
    //////////////////// 以下是分享的資料 //////////////////////////
    shareContent: {
      postId: '',
      avatar: '',
      text: '',
      img: []
    },
    // 來自其他應用的分享所需用到的資料(消息/活動/買迷)
    otherApShareContent: {
      token: '',
      apName: '',
      targetId: '',
      shareUrl: ''
    }
  },
  getters: {
    // avatar(state) {
    //   return state.userInfo['HeadShot'];
    // },
    // nickName(state) {
    //   return state.userInfo['NickName'];
    // },
    friendName(state) {
      return state.testdata.friendList.map(item => {
        return item.friend_displayName;
      });
    },
    urlTitle(state) {
      return state.urlData.title;
    },
    urlDescription(state) {
      //解析 HTML Entity
      let textArea = document.createElement('textarea');
      textArea.innerHTML = state.urlData.description;
      return textArea.value;
    },
    urlImg(state) {
      return state.urlData.image || state.urlData.favicon;
    },
    getTagFriendIds(state) {
      return state.TagFriend.map(item => item.friend_userId);
    },
    getTagFriendNicknames(state) {
      return state.TagFriend.map(item => item.friend_displayName);
    },
    getTagFriendAvatarUrls(state) {
      return state.TagFriend.map(item => item.friend_avatarUrl);
    },
    // 獲取其他應用分享過來的資料
    otherApShareContent(state) {
      return state.otherApShareContent;
    }
  },
  mutations: {
    // SET_USER_INFO(state, payload) {
    //   state.userInfo = payload;
    // },
    SET_CONTENT(state, payload) {
      state.Content = encodeURI(payload);
    },
    SET_UPLOAD_FILES(state, payload) {
      state.uploadFiles = payload;
      console.log(state.uploadFiles);
    },
    SET_URL(state, payload) {
      state.urlData = payload;
    },
    // url圖片錯誤時啟用
    SET_DEFAULT_IMG(state) {
      state.urlData.image = require('@/assets/img/default_link.jpg');
    },
    // 隱私設定
    SET_PRIVACY(state, payload) {
      console.log(payload);
      state.VisiblePermission = payload;
    },
    // 標記朋友
    SET_FRIEND(state, payload) {
      console.log(payload);
      state.TagFriend = payload;
    },
    //////////////////// 以下是分享的資料 //////////////////////////
    SET_SHARE_POSTID(state, payload) {
      state.shareContent.postId = payload;
    },
    SET_SHARE_AVATAR(state, payload) {
      state.shareContent.avatar = payload;
    },
    SET_SHARE_TEXT(state, payload) {
      state.shareContent.text = decodeURI(payload);
    },
    SET_SHARE_IMG(state, payload) {
      state.shareContent.img = payload.map(item => {
        return `${process.env.VUE_APP_PICTURE_PATH}${item}`;
      });
    },
    // 存下來自其他應用分享的資料
    SET_OTHER_AP_SHARE_DATA(state, payload) {
      let shareUrl = '';
      let data = payload;
      if (payload.apName === 'news') {
        shareUrl = `https://news.lale.im/article.do?artId=${payload.targetId}`;
      } else if (payload.apName === 'memiaItem') {
        shareUrl = `https://memia.lale.im/Memia/StoreItemShow.do?action=showItemOfMemia&itemID=${payload.targetId}`;
      } else if (payload.apName === 'memiaShop') {
        shareUrl = `https://memia.lale.im/Memia//StoreOverView.do?action=showStoreOverView&comID=${payload.targetId}`;
      } else if (payload.apName === 'activity') {
        shareUrl = `https://activity.lale.im/activity/detail?id=${payload.targetId}`;
      } else if (payload.apName === 'lotteryShare') {
        shareUrl = `https://activity.lale.im/activity/lotteryShare?id=${payload.targetId}`;
      } else {
        shareUrl = `https://${payload.targetId}`;
      }

      data.shareUrl = shareUrl;
      state.otherApShareContent = Object.assign(state.otherApShareContent, data);
    }
  },
  actions: {
    // 拿要分享的貼文資料
    getShareData(context, postId) {
      context.commit('SET_SHARE_POSTID', postId);
      Loading.show();
      const api = `${process.env.VUE_APP_API_PATH}/showOnePost`;
      let formData = new FormData();
      formData.append('PostId', postId);
      axios
        .post(api, formData)
        .then(res => {
          console.log(res);
          context.commit('SET_SHARE_AVATAR', res.data.MemObj.HeadShot);
          context.commit('SET_SHARE_TEXT', res.data.Content);
          context.commit('SET_SHARE_IMG', res.data.imgSet);
          context.commit('SET_SHARE_IMG', res.data.imgSet);
          console.log(context.state.shareContent);
          Loading.hide();
        })
        .catch(error => {
          console.log(error);
          Loading.hide();
        });
    },
    // 建立新貼文
    createNewPost(context) {
      Loading.show();
      let api = `${process.env.VUE_APP_API_PATH}/createPostForUpload`;
      const formData = new FormData();
      formData.append('Content', context.state.Content);
      // 塞照片
      for (let i = 0; i < context.state.uploadFiles.length; i++) {
        formData.append(`file[${i}]`, context.state.uploadFiles[i]);
      }
      formData.append('VisiblePermission', context.state.VisiblePermission);
      formData.append('TagFriendIds', context.getters.getTagFriendIds);
      formData.append('TagFriendNicknames', context.getters.getTagFriendNicknames);
      formData.append('TagFriendAvatarUrls', context.getters.getTagFriendAvatarUrls);
      axios
        .post(api, formData)
        .then(res => {
          // 清空貼文牆的資料並將頁數歸0
          context.commit('PostWallModule/CLEAR_POST_WALL_DATA', {}, { root: true });
          var screenWidth = screen.width;
          if (screenWidth > 768) {
            router.push({ path: 'Home' });
          } else {
            router.replace({ name: 'PostWall' });
          }
          console.log(res);
          Loading.hide();
        })
        .catch(error => {
          console.log(error);
          Loading.hide();
        });
    },
    // 建立分享貼文(type: 1 = 分享友圈貼文； 2 = 分享其他應用(消息/買迷/活動)到友圈)
    createSharePost(context, type) {
      let api = `${process.env.VUE_APP_API_PATH}/createShare`;
      let content = context.state.Content;
      let sharePostId = context.state.shareContent.postId;
      let visiblePermission = context.state.VisiblePermission;
      let tagFriendIds = context.getters.getTagFriendIds;
      let tagFriendNicknames = context.getters.getTagFriendNicknames;
      let tagFriendAvatarUrls = context.getters.getTagFriendAvatarUrls;

      // 其他華苓應用過來的內容
      if (type === 'ShareOtherPost') {
        content = context.state.Content;
        // 塞組合出來要分享的 URL
        sharePostId = context.state.otherApShareContent.shareUrl;
        visiblePermission = context.state.VisiblePermission;
        tagFriendIds = context.getters.getTagFriendIds;
        tagFriendNicknames = context.getters.getTagFriendNicknames;
        tagFriendAvatarUrls = context.getters.getTagFriendAvatarUrls;
      }

      const formData = new FormData();
      formData.append('Content', content);
      formData.append('SharePostId', sharePostId);
      formData.append('VisiblePermission', visiblePermission);
      formData.append('TagFriendIds', tagFriendIds);
      formData.append('TagFriendNicknames', tagFriendNicknames);
      formData.append('TagFriendAvatarUrls', tagFriendAvatarUrls);
      axios
        .post(api, formData)
        .then(res => {
          // 清空貼文牆的資料並將頁數歸0
          context.commit('PostWallModule/CLEAR_POST_WALL_DATA', {}, { root: true });
          var screenWidth = screen.width;
          if (screenWidth > 768) {
            router.replace({ name: 'Home' });
          } else {
            router.replace({ name: 'PostWall' });
          }

          console.log(res);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 用外部API解析URL
    parseURL(context, payload) {
      let url = payload[0];
      let isYouTube = url.indexOf('youtu.be') > -1 || url.indexOf('youtube.com') > -1;
      let api = `https://url-metadata.herokuapp.com/api/metadata?url=${url}`;
      // youtube 網址使用特定的 API 做解析
      if (isYouTube) {
        api = `https://www.youtube.com/oembed?url=${url}&format=json`;
      }
      axios
        .get(api)
        .then(response => {
          if (isYouTube) {
            // 適用 youtube 的解析格式
            let urlData = response.data;
            context.state.urlData.description = urlData.author_name;
            context.state.urlData.title = urlData.title;
            context.state.urlData.image = urlData.thumbnail_url;
            context.state.urlData.isFinish = true;
          } else {
            context.state.urlData = response.data.data;
          }
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
